import { NgModule } from '@angular/core';
import { PageInfoComponent } from './page-info.component';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    PageInfoComponent
  ],
  exports: [
    PageInfoComponent
  ]
})
export class PageInfoModule { }
